<template>
  <div>
    <span class="d-block">{{getDescription(toggleDescription)}}</span>
    <v-btn small class="mt-1" outlined color='primary' v-if="showMoreDescription" @click="(toggleDescription = !toggleDescription)">
      <span v-if="toggleDescription">Show More</span>
      <span v-else>Show Less</span>
    </v-btn>
  </div>
</template>

<script>
  const maxLenght = 250;
  export default {
    name: "showMoreLess",
    props: ['text', 'maxLength'],
    data() {
      return {
        showMoreDescription: false,
        toggleDescription: true,
        max: this.maxLength ? this.maxLength : maxLenght
      }
    },
    mounted(){
      this.showMoreDescription = this.text && this.text.length > this.max;
    },
    methods: {
      getDescription(toggleDescription) {
        return toggleDescription ? (this.text.length > this.max ? `${this.text.slice(0, this.max)}...` : this.text) : this.text;
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Widgets/showMoreLess.vue